export const HERO_CHIPS = ['💜 6 Tomos + 6 Bonos', '⚡ Acceso en 5 min', '🔒 Pago seguro'];
export const STATS = [{
  value: '+500',
  label: 'Mujeres que ya lo tienen'
}, {
  value: '6',
  label: 'Tomos completos'
}, {
  value: '6',
  label: 'Bonos incluidos'
}, {
  value: '4.9⭐',
  label: 'Calificación promedio'
}];
export type Testimonio = {
  quote: string;
  initials: string;
  name: string;
  place: string;
};
export const TESTIMONIOS_TOP: Testimonio[] = [{
  quote: 'El test de 30 señales del Tomo I me mostró lo que sabía pero no podía ver. Lo cambió todo.',
  initials: 'MG',
  name: 'Mariela G.',
  place: 'Córdoba'
}, {
  quote: 'Por fin tenía una hoja de ruta para los momentos difíciles. No tuve que improvisar sola a las 3AM.',
  initials: 'LP',
  name: 'Laura P.',
  place: 'Rosario · 2 hijos'
}, {
  quote: 'Cuando llegó el momento, tenía la lista, la cuenta y el plan. No lo hice sola.',
  initials: 'RM',
  name: 'Romina M.',
  place: 'Buenos Aires'
}];
export const TESTIMONIOS_BOTTOM: Testimonio[] = [{
  quote: 'El Kit SOS me salvó las noches más difíciles. Por fin tenía algo concreto para hacer.',
  initials: 'CR',
  name: 'Cecilia R.',
  place: '📍 Mendoza'
}, {
  quote: 'El Diario Antigaslighting me devolvió la confianza. Por primera vez pude decir: esto sí pasó.',
  initials: 'PA',
  name: 'Paula A.',
  place: '📍 Neuquén'
}, {
  quote: 'Recuperá Tu Voz me hizo llorar. Pero fue llorar limpio. Escribí lo que quiero por primera vez.',
  initials: 'SC',
  name: 'Sofía C.',
  place: '📍 La Plata'
}];
export const PROBLEMAS = ['Cada vez que intentás irte, volvés: el trauma bonding te hace retroceder.', 'Sola a las 3AM, dudando si lo que viviste "es tan grave".', 'Google no aplica a tu familia ni a tu juzgado de familia.', 'No sabés qué responderle sin engancharte ni perder terreno.', 'Te sentís "exagerada" y ya dudás de tu propia percepción.'];
export type Tomo = {
  numero: string;
  tomo: string;
  titulo: string;
  descripcion: string;
  tags: string[];
};
export const TOMOS: Tomo[] = [{
  numero: '01',
  tomo: 'TOMO I',
  titulo: 'El Despertar',
  descripcion: 'Las 12 máscaras del maltratador. Gaslighting. Test de 30 señales. Trauma bonding. Hoja de trabajo para nombrar lo que vivís.',
  tags: ['Test 30 señales', '12 máscaras', 'Gaslighting']
}, {
  numero: '02',
  tomo: 'TOMO II',
  titulo: 'Anatomía del Abuso',
  descripcion: 'Neurociencia del trauma. 6 tipos de abuso invisibles. Abuso financiero y digital. Codependencia y creencias que sostienen el vínculo.',
  tags: ['Neurociencia', 'Abuso financiero ARG', 'Codependencia']
}, {
  numero: '03',
  tomo: 'TOMO III',
  titulo: 'El Escudo Invisible',
  descripcion: 'Piedra Gris avanzada. WhatsApp estratégico. Conversaciones difíciles. Plan de salida silencioso — 7 pilares.',
  tags: ['Piedra Gris', 'WhatsApp protocolo', '7 pilares']
}, {
  numero: '04',
  tomo: 'TOMO IV',
  titulo: 'El Salto de Libertad',
  descripcion: 'Logística de salida en Argentina. Ley 26.485, denuncia, perimetral. Los primeros 30 días. Hijos, vivienda y economía.',
  tags: ['Ley 26.485', 'Primeros 30 días', 'Hijos y vivienda']
}, {
  numero: '05',
  tomo: 'TOMO V',
  titulo: 'Contacto Cero Real',
  descripcion: '12 disparadores y cómo sobrevivirlos. Las 6 etapas del duelo real. Señales de progreso. Carta de Liberación.',
  tags: ['12 disparadores', '6 etapas duelo', 'Carta de Liberación']
}, {
  numero: '06',
  tomo: 'TOMO VI',
  titulo: 'Sanación Profunda',
  descripcion: 'Reprogramar creencias. Romper el patrón de atracción. Amor propio real. Manifiesto de tu Nueva Vida.',
  tags: ['Reprogramación', 'Manifiesto', 'Carta al Futuro']
}];
export const TOMO_INCLUYE = ['Hojas de trabajo', 'Checklists', 'Scripts reales', 'Recursos legales ARG', '100% PDF inmediato'];
export type Bono = {
  numero: string;
  emoji: string;
  titulo: string;
  descripcion: string;
  valor: string;
};
export const BONOS: Bono[] = [{
  numero: 'BONO 01',
  emoji: '🆘',
  titulo: 'Kit SOS Claridad Emocional',
  descripcion: '10 minutos para cuando la culpa quiera hacerte volver. Frases ancla + tarjeta imprimible.',
  valor: '$12.000'
}, {
  numero: 'BONO 02',
  emoji: '📓',
  titulo: 'Diario Antigaslighting',
  descripcion: 'Volvé a confiar en tu percepción. Registro de hechos y tabla hecho vs. interpretación.',
  valor: '$10.000'
}, {
  numero: 'BONO 03',
  emoji: '💬',
  titulo: 'Scripts para WhatsApp',
  descripcion: '50+ respuestas listas. Culpa, amenazas, love bombing y Contacto Mínimo.',
  valor: '$11.000'
}, {
  numero: 'BONO 04',
  emoji: '🔐',
  titulo: 'Seguridad Digital',
  descripcion: 'Celular, cuentas y ubicación protegidos en 30 minutos. Plan de 7 días.',
  valor: '$10.000'
}, {
  numero: 'BONO 05',
  emoji: '📅',
  titulo: 'Tracker 30 días',
  descripcion: 'Seguimiento diario del Contacto Cero. Frase ancla + calendario visual.',
  valor: '$9.000'
}, {
  numero: 'BONO 06',
  emoji: '🗣️',
  titulo: 'Recuperá Tu Voz',
  descripcion: 'Volvé a escuchar lo que querés y necesitás. Mapa de deseos, límites e identidad.',
  valor: '$10.000'
}];
export type Plan = {
  eyebrow: string;
  titulo: string;
  bajada: string;
  valorReal: string;
  precio: string;
  valorNumerico: number;
  cta: string;
  url: string;
  destacado: boolean;
  features: string[];
};
export const PLANES: Plan[] = [{
  eyebrow: 'MEGAPACK',
  titulo: 'Libertad y Sanación',
  bajada: 'Del despertar a la sanación — todas las etapas',
  valorReal: 'Valor real: $81.000 ARS',
  precio: '$19.990',
  valorNumerico: 19990,
  cta: '💜 QUIERO MI MEGAPACK',
  url: 'https://www.tubrujuladigital.online/cart/54420716945774:1',
  destacado: false,
  features: ['6 Tomos completos (300+ pág.)', '6 Bonos estratégicos', 'Scripts + Tracker + Workbooks', 'Recursos legales para Argentina', 'Acceso inmediato — 100% PDF']
}, {
  eyebrow: 'MEGAPACK + SOBERANA',
  titulo: 'Libertad Total',
  bajada: 'Para quienes necesitan independencia financiera y legal real',
  valorReal: 'Valor real: $112.000 ARS',
  precio: '$27.990',
  valorNumerico: 27990,
  cta: '→ QUIERO MEGAPACK + SOBERANA',
  url: 'https://www.tubrujuladigital.online/cart/54420720583022:1',
  destacado: true,
  features: ['Todo el MegaPack completo', '+ Soberana: Independencia Total', '+ Blindaje Financiero Argentina', '+ Módulo Legal completo', '+ Plan Maestro a 12 meses']
}];
export const COMPARATIVA = [{
  sin: 'Volvés al ciclo sin entender el trauma bonding',
  con: 'Entendés el mecanismo y lo interrumpís'
}, {
  sin: 'Google no aplica a tu realidad argentina',
  con: 'Adaptado: Ley 26.485, ANSES, Línea 144'
}, {
  sin: 'Sin scripts — improvisás y perdés terreno',
  con: '50+ scripts listos para copiar'
}, {
  sin: 'Contacto Cero que se rompe solo',
  con: 'Tracker 30 días + protocolos de crisis'
}, {
  sin: 'Dudás de tu percepción — "¿soy exagerada?"',
  con: 'Diario Antigaslighting te devuelve la confianza'
}];
export const FAQS = [{
  q: '¿Sirve si todavía no salí?',
  a: 'Sí. Los Tomos I, II y III están pensados para ese momento. Entendés, te protegés y preparás la salida sin exponerte.'
}, {
  q: '¿Sirve si ya salí pero sigo enganchada?',
  a: 'Completamente. Los Tomos IV, V y VI acompañan el proceso post-separación: Contacto Cero, duelo y sanación.'
}, {
  q: '¿Cómo recibo el material?',
  a: 'Inmediatamente. Tras el pago llega un mail con el enlace. Acceso en 5 minutos. 100% PDF.'
}, {
  q: '¿Reemplaza la terapia?',
  a: 'No. Son herramientas prácticas que complementan el proceso terapéutico — no lo reemplazan.'
}, {
  q: '¿Garantía real?',
  a: '7 días, 100% de devolución sin preguntas. Menos del 1% de devoluciones.'
}];
export const PRODUCT_IMAGE = 'https://cdn.magicpatterns.com/uploads/utU396x4kPzeHcTXaSJgzx/lLISTO.jpg';